import createTableStore from "ds/components/Table/store/useTableStore";

import { SPACES_LIST_COLUMN_CONFIG, SPACES_LIST_COLUMNS_STORAGE_KEY } from "./constants";

const useSpacesListTableStore = createTableStore({
  storageKey: SPACES_LIST_COLUMNS_STORAGE_KEY,
  config: SPACES_LIST_COLUMN_CONFIG,
  version: 3,
});

export default useSpacesListTableStore;
